/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcphosted_Hub_Url_LabelInputs */

const en_mcphosted_hub_url_label = /** @type {(inputs: Mcphosted_Hub_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connector URL`)
};

const id_mcphosted_hub_url_label = /** @type {(inputs: Mcphosted_Hub_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL konektor`)
};

/**
* | output |
* | --- |
* | "Connector URL" |
*
* @param {Mcphosted_Hub_Url_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mcphosted_hub_url_label = /** @type {((inputs?: Mcphosted_Hub_Url_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcphosted_Hub_Url_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mcphosted_hub_url_label(inputs)
	return en_mcphosted_hub_url_label(inputs)
});